import {LoggedStatus, ModuleFE_Account, OnLoginStatusUpdated} from '@nu-art/user-account/frontend';
import {Module} from '@nu-art/ts-common';
import {ModuleFE_Stores} from '@modules/index';
import {ModuleFE_BrowserHistory, ModuleFE_Routing, ModuleFE_Thunderstorm, StorageKey} from '@nu-art/thunderstorm/frontend';
import {RouteKey_Home} from '@consts/routes-consts';
import {ModuleFE_SyncManagerV2} from '@nu-art/thunderstorm/frontend/modules/sync-manager/ModuleFE_SyncManagerV2';


export class ModuleFE_App_Class
	extends Module
	implements OnLoginStatusUpdated {

	sideBarIsOpen = new StorageKey<boolean>('global-config__side-bar__open');

	constructor() {
		super();
	}

	protected init() {
		this.runAsync('fetch stores', async () => {
			ModuleFE_Stores.v1.sync().execute();
		});

		window.addEventListener('unload', function unloadListener() {
			console.log(`href: ${window.location.href}`);
		});
	}

	async __onLoginStatusUpdated() {
		const myRouteKey = ModuleFE_Routing.getMyRouteKey();
		if (ModuleFE_Account.isStatus(LoggedStatus.LOGGED_IN)) {
			ModuleFE_SyncManagerV2.v1.checkSync().execute();
			const redirectUrl = ModuleFE_BrowserHistory.getQueryParameter('redirectUrl');
			if (redirectUrl)
				window.location.href = (redirectUrl as string);

		} else if (ModuleFE_Account.isStatus(LoggedStatus.LOGGED_OUT)) {
			await ModuleFE_Thunderstorm.clearWebsiteData();
			if (myRouteKey !== RouteKey_Home)
				ModuleFE_Routing.goToRoute(RouteKey_Home, {redirectUrl: window.location.href});
		}
	}
}

export const ModuleFE_App = new ModuleFE_App_Class();
